<template>
  <div id="FeedbackModal">
    <b-modal
      id="feedback-modal"
      size="lg"
      v-bind:modal-class="'feedback-modal ' + getTheme()"
      hide-footer
      hide-header
      @hidden="closeModal()"
    >
    	<div class="buttons-container" v-if="!loading">
			  <b-button @click="closeModal()" variant="white" class="close-button" block><i class="fas fa-times fa-2x brand-text"></i></b-button>
			</div>
      <div
        v-if="loading"
        class="d-flex flex-column align-items-center justify-content-center"
      >
        <b-spinner class="brand-primary"></b-spinner>
      </div>
      <FeedbackThankYou v-else-if="currentQuestion.order === 2" :resetModal="resetModal" />
      <div v-else>
        <h2 class="question_title">
          {{currentQuestion.header}}
        </h2>
        <h3 class="subheading" v-if="currentQuestion.subheader">
          {{currentQuestion.subheader}}
        </h3>
        <FeedbackStep :question="currentQuestion" :answer="answer" :setAnswer="setAnswer" />
        <div
          class="d-flex justify-content-end align-items-center dmh-start-btn-container"
        >
          <b-button
            class="btn-previous"
            size="lg"
            squared
            v-if="currentQuestion.order === 1"
            @click="handlePrevious"
          >Previous
          </b-button
          >
          <b-button
            class="btn-continue"
            size="lg"
            squared
            v-if="currentQuestion.order < 2"
            :disabled="currentQuestion.isRequired && (currentQuestion.order === 1 && answer.comment.length === 0)"
            @click="handleContinue"
          >Continue
          </b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import NavigationCard from "@/components/Home/New/NavigationCard.vue";
import axios from "axios";
import config from "../../../config/constants";
import FeedbackStep from "@/components/Home/New/FeedbackStep.vue";
import FeedbackThankYou from "@/components/Home/New/FeedbackThankYou.vue";
import ErrorModal from "@/components/GP/ErrorModal.vue";

//TODO: Make this more dynamic to handle multiple questions along with their follow-up questions
//See currentQuestion, and change it accordingly to have a currentFollowupQuestionID and currentQuestionID to handle states more dynamically

export default {
  components: {
    FeedbackThankYou,
    FeedbackStep,
    NavigationCard
  },
  name: "FeedbackModal",
  props: ["currentBookingId"],
  data() {
    return {
      loading: true,
      questions: null, //array containing all the question if they will be more than 1
      currentQuestion: { //current selected question with its data
        order: 0,
        header: null,
        subheader: null,
        type: null,
        slider: null,
        characterLimit: null,
        isRequired: false,
      },
      answer: { //current saved answer for both slider's score and textarea's comment
        score: null,
        comment: null
      }
    };
  },
  async mounted() {
    await this.getFeedbackQuestions();
  },
  methods: {
    closeModal() {
      this.resetModal();
      this.$bvModal.hide("feedback-modal");
    },
    //fetching feedback questions data
    async getFeedbackQuestions() {
      const payload = {
        user_id: this.$store.getters.user_id
      };
      const res = await axios.post(config.api_env + "/application/api/u/questionnaire/get-nps-questions", payload, config.options);
      if (res.data.success && res.data.nps_questions) {
        this.questions = res.data.nps_questions;
        const question = res.data.nps_questions.nps_questions[0];
        this.currentQuestion = {
          order: 0,
          header: question.question_text,
          subheader: question.sub_heading,
          type: question.question_type,
          slider: question.slider,
          follow_up_questions: question.follow_up_questions,
          isRequired: question.is_required,
        };
        this.answer = {
          score: res.data.nps_questions.nps_questions[0].slider.default_value,
          comment: ""
        };
      } else if (res.data.err && res.data.err.includes("3994")) {
        await this.$store.dispatch("logout");
      }
      this.loading = false;
    },
    //handling either continue after selecting a value on the slider, or to submit all values at the end
    async handleContinue() {
      switch (this.currentQuestion.order) {
        case 0:
          this.questions.nps_questions[0].follow_up_questions.map((question) => {
            if (this.answer.score >= question.answer_min_threshold && this.answer.score <= question.answer_max_threshold) {
              this.currentQuestion = {
                order: 1,
                header: question.question.question_text,
                subheader: question.question.question_description,
                type: question.question.answer_type,
                characterLimit: question.question.character_limit,
                isRequired: question.is_required,
              };
            }
          });
          break;
        case 1:
        default:
          await this.submitAnswer();
          break;
      }
    },
    //handling going back to change slider's value
    handlePrevious() {
      this.currentQuestion = {
        order: 0,
        header: this.questions.nps_questions[0].question_text,
        subheader: this.questions.nps_questions[0].sub_heading,
        type: this.questions.nps_questions[0].question_type,
        slider: this.questions.nps_questions[0].slider
      };
    },
    //generic method to be passed to all children components for saving answers
    setAnswer(value, variable) {
      this.answer[variable] = value;
    },
    //final submission API call for all saved values
    async submitAnswer() {
      const payload = {
        user_id: this.$store.getters.user_id,
        question_id: this.questions.nps_questions[0].question_id,
        nps_rating: this.answer.score,
        nps_comment: this.answer.comment,
        nps_questions_version: this.questions.nps_questions_version,
        sf_appointment_id: this.currentBookingId
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/questionnaire/submit-nps-answer",
        payload,
        config.options
      );
      if (res.data.success) {
        this.currentQuestion.order = 2;
      } else {
        this.openErrorModal(res.data.message, "");
      }
    },
    //handling error state if submission did not work
    openErrorModal(title, error, redirect) {
      const content = this.$createElement(ErrorModal, { props: { title, error, redirect } });
      const skin = this.$store.getters.skin;
      let opts = {
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: "error-modal"
      };
      return this.$bvModal.msgBoxOk(content, opts).then(value => {
        this.closeModal();
      })
    },
    //resting the modal if have been used before a new refresh
    async resetModal() {
      await this.getFeedbackQuestions();
    }
  }
};
</script>
<style lang="less">

#feedback-modal {
  
  .modal-body {
    padding: 80px;
    display: flex;
    flex-direction: column;
    max-width: 719px;
  }
  
  .modal-content {
    border-radius: 0;
    overflow: auto;
    max-height: 90vh;
    max-width: 720px;
    align-items: center;
  }
  
  .question_title {
    color: #1e1e22;
    text-align: left;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0;
    padding: 0;
    font-family: "DMSans Bold";
    margin-bottom: 32px;
  }
  
  .subheading {
    font-family: "DMSans";
    color: #1e1e22;
    letter-spacing: normal;
    font-size: 16px;
    padding: 0;
    margin-bottom: 32px;
  }
  
  .dmh-start-btn-container {
    gap: 24px;
    margin-top: 32px;
  }
  .buttons-container {
		position: absolute;
		right: 30px;
		top: 30px;
	}
  .btn-previous {
    border: 1px solid var(--brand-primary);
    padding: 16px;
    color: var(--brand-primary);
    font-family: "DMSans Bold";
    background-color: #fff;
    letter-spacing: normal;
    border-radius: 15px !important;
    
    &:focus {
      background-color: #f6f6f6;
    }
  }
  
  .btn-continue {
    padding: 16px;
    color: #fff;
    font-family: "DMSans Bold";
    background-color: var(--brand-primary);
    letter-spacing: normal;
    border-radius: 15px !important;
  }
}
</style>
